import { createSlice } from "@reduxjs/toolkit";
import { ConfirmationDataAction, ConfirmationToggleAction, setToastDataAction, setToastDisplayAction } from "../actions/ToastAction";
export const ToastSlice = createSlice({
  name: "toast",
  initialState: {
    showToast: false,
    toastData: {
      message: '',
      type: 'error',
      isHtml: false,
      showCloseBtn: true,
      showOkBtn: false
    },
    confirmDisplay: false,
    confirmationData: {}
  },
  reducers: {
    setToastDisplay: setToastDisplayAction,
    setToastData: setToastDataAction,
    ConfirmationToggle: ConfirmationToggleAction,
    setConfirmation: ConfirmationDataAction
  },
});
export const { setToastDisplay, setToastData, ConfirmationToggle, setConfirmation } = ToastSlice.actions;
export default ToastSlice.reducer;